import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronNext = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.96967 18.7803C9.26256 19.0732 9.73744 19.0732 10.0303 18.7803L16.0303 12.7803C16.3232 12.4874 16.3232 12.0126 16.0303 11.7197L10.0303 5.71967C9.73744 5.42678 9.26256 5.42678 8.96967 5.71967C8.67678 6.01256 8.67678 6.48744 8.96967 6.78033L14.4393 12.25L8.96967 17.7197C8.67678 18.0126 8.67678 18.4874 8.96967 18.7803Z",
		fill: "currentColor"
	})
});
export { SvgIconChevronNext as ReactComponent };
